import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import React from "react";
import { Icon } from '../icons/Icons';
import styled from "styled-components";
import { colors } from "../colors/color";

type DragButtonProps = {
    listeners: SyntheticListenerMap,
    setActivatorNodeRef: (element: HTMLElement | null) => void;
};

export const DragButton = (props: DragButtonProps) =>
{
    return (
        <StyledButton {...props.listeners} ref={props.setActivatorNodeRef}>
            <Icon name={"drag_indicator"} color={colors.icon.passive} />
        </StyledButton>
    );
};

const StyledButton = styled.button`
    background: none;
    border: none;
    cursor: grab;

    :hover{
        border: 1px solid ${colors.button.outlined.border};
        svg {
            fill: ${colors.icon.active};
        }
    }
`;